import React from 'react';

import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';

const Wrapper = styled.section`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    font-family: ${props => props.theme.palette.fontFamily};
`;

const WrapperContainer = styled.section`
    height: 100%;
    background: ${props => props.theme.palette.primary.background};
    width: ${props => props.theme.palette.screen.desktop};
    @media (max-width: 767px) {
        width: ${props => props.theme.palette.screen.smallScreen};
    }
`;

const WrapperContent = styled.section`
    height: calc(100% - 40px);
    padding-bottom: calc(120px - 100%);
    overflow: auto;
    background: #f8fafa;
    &:has(.submit-btn) {
        height: calc(100% - 120px);
    }
`;

function AppContainer({ children }) {
    return (
        <Wrapper data-testid="m7sqvznp-vvk8mf">
            <WrapperContainer data-testid="m7sqvznp-zn0yj3">
                <WrapperContent data-testid="m7sqvznp-pk6i4c">
                    {children}
                </WrapperContent>
            </WrapperContainer>
        </Wrapper>
    );
}

AppContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

AppContainer.defaultProps = {};

export default withTheme(AppContainer);
